import React from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Button,
} from 'react-bootstrap5';

export default function Card({
  title, description, image, onClick,
}) {
  return (
    <Row className="resource-card gx-0 h-100">
      <Col xl={4} className="pe-3 image-wrapper">
        <div className="icon-wrapper" style={{ backgroundImage: `url(${image})` }} />
      </Col>
      <Col xl={8} className="content-wrapper">
        <div className="ms-3 me-3">
          <h5 className="title">{title}</h5>
          <div
            className="small description"
          >
            {description}
          </div>
          <div className="d-flex justify-content-between mt-3">
            <Button
              variant="link"
              onClick={() => {

              }}
            >
              Learn More
            </Button>
            <Button
              onClick={onClick}
            >
              Start
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  );
}

Card.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};
